import { observer } from 'mobx-react-lite'

import { AppAvatar } from '@src/app/components'

import type { IncomingCallVia } from './IncomingCallUiStore'
import * as styles from './Via.css'

interface ViaProps {
  via: IncomingCallVia | null
}

const Via = ({ via }: ViaProps) => {
  if (!via) {
    return null
  }

  return (
    <>
      , forwarded by
      <span className={styles.via}>
        <AppAvatar identity={via} hideBadge hideStatus size={16} />
        {via.name}
      </span>
    </>
  )
}

export default observer(Via)
